import { BuildingStorefrontIcon, GlobeAltIcon, PhoneIcon, SwatchIcon } from "@heroicons/react/24/outline";

import StatusPill, { StatusPillColour } from "../shared/StatusPill";
import { IPartRequest, PartRequestSource, PartRequestStatus } from "../../models/partRequests/IPartRequest";
import { PART_REQUEST_SOURCE_LABELS, PART_REQUEST_STATUS_LABELS } from "../../utils/partRequests";

export function PartRequestSourcePill({ source }: { source: PartRequestSource }) {
  const isPartPro = source === PartRequestSource.PartPro;
  return (
    <StatusPill
      text={PART_REQUEST_SOURCE_LABELS[source]}
      colour={isPartPro ? StatusPillColour.Purple : StatusPillColour.Neutral}
      icon={isPartPro ? BuildingStorefrontIcon : PhoneIcon}
    />
  );
}

export function PartRequestStatusPill({ status }: { status: PartRequestStatus }) {
  const colour =
    status === PartRequestStatus.Open
      ? StatusPillColour.Blue
      : status === PartRequestStatus.Claimed
        ? StatusPillColour.Yellow
        : status === PartRequestStatus.Fulfilled
          ? StatusPillColour.Green
          : StatusPillColour.Neutral;
  return <StatusPill text={PART_REQUEST_STATUS_LABELS[status]} colour={colour} />;
}

/** The request's paint code matches the car's - only shown when both sides have one. */
export function PaintMatchPill() {
  return <StatusPill text="Paint match" colour={StatusPillColour.Green} icon={SwatchIcon} />;
}

/** Shown on internal requests that are out with the other yards. */
export function PartRequestNetworkPill({ request }: { request: IPartRequest }) {
  if (!request.isOnNetwork) return null;
  const text = request.offerCount > 0
    ? `On network · ${request.offerCount} offer${request.offerCount === 1 ? "" : "s"}`
    : "On network";
  return (
    <StatusPill
      text={text}
      colour={request.offerCount > 0 ? StatusPillColour.Green : StatusPillColour.Orange}
      icon={GlobeAltIcon}
    />
  );
}
